import { Stack, TextField, Typography } from '@mui/material';
import { comment, pointsNextStep, pointsPreviousStep } from '../../../actions/points';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import StepActions from './StepActions';

export default function Step4() {
  const dispatch = useAppDispatch();
  const text = useAppSelector((s) => s.points.comment);

  return (
    <Stack className="step4" spacing={2} alignItems="flex-start">
      <Typography variant="h6">Komentarz synoptyka</Typography>
      <TextField
        label="Nieobowiązkowy komentarz"
        multiline
        rows={3}
        value={text}
        onChange={(event) => dispatch(comment(event.target.value))}
        sx={{ width: '100%', maxWidth: 480 }}
      />
      <StepActions
        onBack={() => dispatch(pointsPreviousStep())}
        onNext={() => dispatch(pointsNextStep())}
      />
    </Stack>
  );
}
